import { cn } from '../../utils/cn'

export default function ProductTabs({
  tabs = [],
  active,
  onChange,
  activeClass = 'border-b border-[#FF4D1C] text-[#FF4D1C] font-inter-semibold',
}) {
  return (
    <div
      role="tablist"
      className="flex flex-wrap items-center border-b border-[#E5E7EB]"
    >
      {tabs.map(tab => {
        const isActive = tab.id === active

        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange?.(tab.id)}
            className={cn(
              'cursor-pointer px-6 py-3 text-sm uppercase transition-colors duration-200',
              isActive
                ? activeClass
                : 'border-b border-transparent text-[#6A7282] font-inter-regular',
            )}
          >
            {tab.label}
          </button>
        )
      })}
    </div>
  )
}
